import * as React from "react";
import { cn } from "../../lib/utils";

const EmptyState = React.forwardRef(
  ({ className, icon: Icon, title, description, action, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "ui-motion-enter flex flex-col items-center justify-center py-16 px-4 text-center",
        className
      )}
      {...props}
    >
      {Icon && (
        <div className="w-12 h-12 bg-surface-3 flex items-center justify-center mb-4">
          <Icon className="h-6 w-6 text-text-tertiary" />
        </div>
      )}
      {title && (
        <p className="text-sm font-medium text-text-primary mb-1">{title}</p>
      )}
      {description && (
        <p className="text-sm text-text-tertiary max-w-sm mb-6">
          {description}
        </p>
      )}
      {action}
    </div>
  )
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
